import React from "react";
import DOMPurify from "dompurify";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

function Awarding({awardingData}) {

    //console.log(awardingData);

    return (
        <>
            {
                awardingData ?

                    <section className="relative py-20 lg:h-96 xl:h-[810px] flex flex-col gap-5 justify-center">
                        <img src={awardingData.awarding_photo} className="absolute top-0 left-0 object-cover -z-10 w-full h-full"/>
                        <div className="container max-w-screen-xl mx-auto px-[15px]">
                            <div className="text-white text-center">
                                <ScrollAnimation animateIn="animate__fadeInUp"><h2 className="text-2xl font-semibold mb-5 lg:text-4xl xl:text-5xl">{awardingData.awarding_title}</h2></ScrollAnimation>
                               <ScrollAnimation animateIn="animate__fadeInUp"><div className="text-xl" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(awardingData.awarding_text, {sanitize: true})}} /></ScrollAnimation>
                            </div>
                        </div>
                    </section>
                     : ''
            }
        </>
    )
}

export default Awarding